import { Question } from 'inquirer'

export interface Credentials {
  accessKeyId: string
  secretAccessKey: string
}

export interface UtilsConfig {
  credentials: Credentials
  region?: string
}

export interface ExtendedQuestion extends Question {
  choices?: string[]
  transformer?: (text: string, answers: Record<string, unknown>, flags: Record<string, unknown>) => string
}

export interface AwsAccessAnswers {
  awsAccessKeyId: string
  awsSecretAccessKey: string
}

export interface AwsRegionAnswers {
  awsRegion: string
}

export interface AwsS3AndIAMUserQuestions {
  awsIAMUserName: string
  awsS3BucketName: string
}
